export default function Legacy() {
  return (
    <div id="our-Legacy">
      <h1
        style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          color: 'blue',
          textAlign: 'center', 
          marginBottom: '1rem', 
        
        }}
      >
        Our Legacy
      </h1>
      <br/>
      <p style={{ marginLeft: "40px", marginRight: "40px",fontSize:'18px' }}>
        For over 10 years, Sapphire Electronics has been a beacon of trust and excellence in audio
        and video repair. Our unmatched craftsmanship and dedication ensure your devices not
        only work—but shine. We don’t just fix electronics; we restore your connection to
        sound and vision.
      </p>
    </div>
  );
}
